import VueRouter from "vue-router";
import store from "./store";
import { gtag } from "./plugins/ga4";

const routes = [
  { path: "/", name: "/", component: () => import("@/views/HomePage.vue") },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginPage.vue"),
  },
  { path: "/buy", name: "buy", component: () => import("@/views/BuyPage.vue") },
  {
    path: "/myqr",
    name: "myqr",
    component: () => import("@/views/MyQrPage.vue"),
  },
  {
    path: "/gift",
    name: "gift",
    component: () => import("@/views/GiftPage.vue"),
  },
  {
    path: "/statement",
    name: "statement",
    component: () => import("@/views/StatementPage.vue"),
  },
  {
    path: "/feeds",
    name: "feeds",
    component: () => import("@/views/FeedsPage.vue"),
  },
  {
    path: "/feedform",
    name: "feedform",
    component: () => import("@/views/FeedFormPage.vue"),
  },
  {
    path: "/feedview",
    name: "feedview",
    component: () => import("@/views/FeedViewPage.vue"),
  },
  {
    path: "/topup",
    name: "topup",
    component: () => import("@/views/TopupPage.vue"),
  },
  {
    path: "/advisor",
    name: "advisor",
    component: () => import("@/views/AdvisorPage.vue"),
  },
  {
    path: "/changepassword",
    name: "changepassword",
    component: () => import("@/views/ChangePasswordPage.vue"),
  },
  {
    path: "/editprofile",
    name: "editprofile",
    component: () => import("@/views/EditProfilePage.vue"),
  },
  {
    path: "/shoppings",
    name: "shoppings",
    component: () => import("@/views/ShoppingsPage.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("@/views/ProfilePage.vue"),
  },
  {
    path: "/buyhistory",
    name: "buyhistory",
    component: () => import("@/views/BuyHistoryPage.vue"),
  },
  {
    path: "/registerPhone",
    name: "registerPhone",
    component: () => import("@/views/RegisterPhone.vue"),
  },
  {
    path: "/registerOTP",
    name: "registerOTP",
    component: () => import("@/views/RegisterOTP.vue"),
  },
  {
    path: "/registerForm",
    name: "registerForm",
    component: () => import("@/views/RegisterForm.vue"),
  },
  {
    path: "/forgotPassword",
    name: "/forgotPassword",
    component: () => import("@/views/ForgetPassword.vue"),
  },
  {
    path: "/help",
    name: "help",
    component: () => import("@/views/HelpPage.vue"),
  },
  {
    path: "/drawhistory",
    name: "drawhistory",
    component: () => import("@/views/DrawHistoryPage.vue"),
  },
  {
    path: "/myreferal",
    name: "myreferal",
    component: () => import("@/views/MyReferralPage.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/AboutPage.vue"),
  },
  {
    path: "/requestnumber",
    name: "requestnumber",
    component: () => import("@/views/RequestNumberPage.vue"),
  },
  {
    path: "/luckydraw",
    name: "luckydraw",
    component: () => import("@/views/LuckyDrawPage.vue"),
  },
  {
    path: "/horoscopes",
    name: "horoscopes",
    component: () => import("@/views/HoroscopesPage.vue"),
  },
  {
    path: "/horoscope",
    name: "horoscope",
    component: () => import("@/views/HoroscopePage.vue"),
  },
  {
    path: "/shoppingcart",
    name: "shoppingcart",
    component: () => import("@/views/ShoppingCartPage.vue"),
  },
  {
    path: "/shop",
    name: "shop",
    component: () => import("@/views/ShopPage.vue"),
  },
  {
    path: "/banks",
    name: "banks",
    component: () => import("@/views/BanksPage.vue"),
  },
  {
    path: "/delete-account",
    name: "delete-account",
    component: () => import("@/views/DeleteAccountPage.vue"),
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // Track page views with Google Analytics 4
  if (typeof gtag !== "undefined") {
    gtag("event", "page_view", {
      page_path: to.path,
      page_title: to.name || to.path,
    });
  }

  if (
    ![
      "/",
      "/shoppings",
      "/shoppingcart",
      "/shop",
      "/login",
      "/help",
      "/topup",
      "/registerPhone",
      "/registerOTP",
      "/registerForm",
      "/forgotPassword",
      "/delete-account",
      "/horoscopes",
      "/horoscope",
      "/requestnumber",
      "/drawhistory",
    ].includes(to.path)
  ) {
    if (!store.get("user")) {
      if (router.currentRoute.path !== "/") {
        router.replace({ path: "/" });
      }
    }
  }
  next();
});

export default router;
